import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgThumbsUp({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.681 19.5H5a3 3 0 01-3-3v-6a3 3 0 013-3h2.29a3 3 0 01.511-.756l4.23-4.559.012-.012a2.18 2.18 0 013.137-.014c.52.533.74 1.287.597 2.017l-.539 2.823h2.712a4 4 0 013.677 5.576l-2.188 5.106a3 3 0 01-2.758 1.818zM7 16.5v-7H5a1 1 0 00-1 1v6a1 1 0 001 1h2.17c-.11-.314-.17-.65-.17-1zm2.267-8.396a1 1 0 00-.267.68V16.5a1 1 0 001 1h6.681a1 1 0 00.92-.606l2.188-5.106a2 2 0 00-1.839-2.788h-5.13l.227-1.187.766-4.016a.263.263 0 00-.058-.234c-.081-.082-.19-.083-.265-.008l-4.223 4.55z"
        fill={color}
      />
    </svg>
  )
}

export default SvgThumbsUp
